import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useCart } from "../component/Cart/CartContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Productpage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const { id } = useParams();

  // 1. Data Fetch State
  const [fetchedProduct, setFetchedProduct] = useState(null);
  const [loading, setLoading] = useState(!location.state?.product);

  const product = location.state?.product || fetchedProduct;

  // 2. UI State
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedSku, setSelectedSku] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(0);

  // Initialize selectedVariant when product loads
  useEffect(() => {
    if (product?.variants?.length > 0 && !selectedVariant) {
      setSelectedVariant(product.variants[0]);
    }
  }, [product, selectedVariant]);

  // Update selectedSku when selectedVariant changes
  useEffect(() => {
    if (selectedVariant?.skus?.length > 0) {
      // Default to first size or reset
      setSelectedSku(null);
    }
  }, [selectedVariant]);

  // Fetch product if needed
  useEffect(() => {
    if (!location.state?.product && id) {
      const fetchProduct = async () => {
        try {
          const API_URL = process.env.REACT_APP_API_URL || "";
          const res = await fetch(`${API_URL}/api/products/details/${id}`);
          const data = await res.json();
          if (data) {
            setFetchedProduct(data);
          } else {
            toast.error("Product not found");
          }
        } catch (error) {
          console.error("Error fetching product:", error);
          toast.error("Failed to load product");
        } finally {
          setLoading(false);
        }
      };
      fetchProduct();
    } else if (location.state?.product) {
      setLoading(false);
    }
  }, [id, location.state?.product]);

  const productImages = selectedVariant?.images || [];

  // Auto-slide
  useEffect(() => {
    if (productImages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === productImages.length - 1 ? 0 : prev + 1
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [productImages.length]);

  if (loading) return <div className="flex justify-center items-center h-screen"><p>Loading...</p></div>;
  if (!product) return <div className="flex flex-col justify-center items-center h-screen gap-4"><p>Product not found</p><button onClick={() => navigate("/")} className="bg-black text-white px-6 py-2 rounded">Go Home</button></div>;

  const handleVariantSelect = (variant) => {
    setSelectedVariant(variant);
    setCurrentIndex(0);
  };

  const handleSizeSelect = (sku) => {
    setSelectedSku(sku);
    setQuantity(1);
  };

  const increaseQuantity = () => {
    if (selectedSku && quantity < selectedSku.quantity) {
      setQuantity((prev) => prev + 1);
    } else if (!selectedSku) {
      toast.error("Select a size first");
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) setQuantity((prev) => prev - 1);
  };

  const handleAddToCart = () => {
    if (!selectedSku) {
      toast.error("Please select a size!");
      return;
    }

    // Determine price based on SALE logic
    // Usually cart uses one unit price. 
    // If product is on sale, use finalPrice, else base price.
    // Ensure numbers.
    const finalPrice = product.sale?.isOnSale ? product.sale.finalPrice : product.price;

    const cartItem = {
      id: product._id,
      name: product.model,
      image: productImages[0]?.src,
      price: finalPrice,
      size: selectedSku.value,
      color: selectedVariant?.color?.name || "Default", // Add color info
      quantity: quantity,
      variantId: selectedVariant?._id // Track variant ID
    };

    addToCart(cartItem);
    toast.success(`${product.model} added to cart!`);
  };

  const handleBuyNow = () => {
    if (!selectedSku) {
      toast.error("Please select a size first!");
      return;
    }
    navigate("/checkout");
  };

  // Touch handlers
  const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
  const handleTouchEnd = (e) => {
    const diff = e.changedTouches[0].clientX - touchStartX;
    if (diff > 50) setCurrentIndex((prev) => (prev === 0 ? productImages.length - 1 : prev - 1));
    else if (diff < -50) setCurrentIndex((prev) => (prev === 0 ? productImages.length - 1 : prev + 1));
  };


  return (
    <section className="py-16 poppins px-4 lg:px-[150px] flex flex-col md:flex-row items-center">
      {/* Images Carousel */}
      <div className="w-full md:w-1/2 flex justify-center">
        <div className="w-full max-w-[350px] overflow-hidden relative rounded-xl shadow">
          {/* Slider */}
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            {productImages.map((img) => (
              <img
                key={img._id}
                src={img.src}
                alt={product.model}
                className="min-w-full object-cover"
              />
            ))}
          </div>

          {/* Dots */}
          <div className="absolute bottom-2 w-full flex justify-center gap-2">
            {productImages.map((_, i) => (
              <div
                key={i}
                onClick={() => setCurrentIndex(i)}
                className={`w-3 h-3 rounded-full cursor-pointer transition 
            ${currentIndex === i ? "bg-black" : "bg-gray-300"}
          `}
              ></div>
            ))}
          </div>
        </div>
      </div>


      {/* PRODUCT INFO 
      <!-- Meta Pixel Code -->
<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '1834030197134074');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1" style="display:none"
src="https://www.facebook.com/tr?id=1834030197134074&ev=PageView&noscript=1"
/></noscript>
<!-- End Meta Pixel Code -->*/}
      <div className="w-full md:w-1/2 px-6">
        <h1 className="text-3xl font-bold mb-4">{product.model}</h1>

        {/* PRICE DISPLAY */}
        <div className="mb-4">
          {product.sale?.isOnSale ? (
            <div className="flex items-center gap-3">
              <span className="text-2xl font-bold text-red-500">
                {product.sale.finalPrice.toLocaleString()} DT
              </span>
              <span className="text-lg text-gray-400 line-through">
                {product.price.toLocaleString()} DT
              </span>
              <span className="bg-red-100 text-red-600 text-xs px-2 py-1 rounded">
                Save {product.sale.discountValue}{product.sale.discountType === 'percentage' ? '%' : ' DT'}
              </span>
            </div>
          ) : (
            <p className="text-2xl font-semibold text-gray-800">
              {product.price.toLocaleString()} DT
            </p>
          )}
        </div>

        <p className="mt-4 text-gray-600">{product.description}</p>

        {/* COLOR SELECTION */}
        {product.variants?.length > 0 && (
          <div className="mt-6">
            <p className="text-lg font-semibold mb-2">Color: <span className="text-gray-500 text-sm font-normal">{selectedVariant?.color?.name}</span></p>
            <div className="flex gap-3">
              {product.variants.map((variant) => (
                <button
                  key={variant._id}
                  onClick={() => handleVariantSelect(variant)}
                  className={`w-10 h-10 rounded-full border-2 transition relative flex justify-center items-center
                    ${selectedVariant?._id === variant._id ? "border-black" : "border-gray-200 hover:border-gray-400"}
                  `}
                  title={variant.color?.name}
                  style={{ backgroundColor: variant.color?.hex || '#000' }}
                >
                  {selectedVariant?._id === variant._id && (
                    <span className="block w-2 h-2 bg-white rounded-full"></span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* SIZE SELECTOR */}
        <div className="mt-6">
          <p className="text-lg font-semibold mb-2">Size:</p>
          <div className="flex gap-3 flex-wrap">
            {selectedVariant?.skus?.map((sku) => (
              <button
                key={sku._id}
                onClick={() => handleSizeSelect(sku)}
                disabled={sku.quantity === 0}
                className={`border px-4 py-2 rounded transition min-w-[3rem] 
                  ${selectedSku?._id === sku._id
                    ? "bg-black text-white border-black"
                    : sku.quantity === 0
                      ? "bg-gray-100 text-gray-300 cursor-not-allowed border-gray-100 decorative-line-through"
                      : "hover:border-black"
                  }
                `}
              >
                {sku.value}
              </button>
            ))}
          </div>
          {selectedSku ? (
            <p className="text-xs text-gray-500 mt-2">
              Available: {selectedSku.quantity}
            </p>
          ) : (
            <p className="text-xs text-red-400 mt-2 min-h-[1rem]">Please select a size</p>
          )}
        </div>

        {/* QUANTITY */}
        <div className="mt-6">
          <p className="text-lg font-semibold mb-2">Quantity:</p>
          <div className="flex items-center">
            <button className="border px-3 py-1" onClick={decreaseQuantity}>
              -
            </button>
            <span className="px-4">{quantity}</span>
            <button className="border px-3 py-1" onClick={increaseQuantity}>
              +
            </button>
          </div>
          {selectedSku && (
            <p className="text-xs text-gray-500 mt-1">
              Max available: {selectedSku.quantity}
            </p>
          )}
        </div>

        {/* BUTTONS */}
        <div className="mt-8 flex gap-4">
          <button
            className="border md:px-6 md:py-3 w-full rounded"
            onClick={handleAddToCart}
          >
            Add to Cart
          </button>
          <button
            className="bg-black text-white px-2 py-2 md:px-6 md:py-3 w-full rounded"
            onClick={handleBuyNow}
          >
            Buy it Now
          </button>
        </div>

        <p className="text-[10px] text-gray-500 mt-6">
          *Add product to the cart before proceeding to buy.
        </p>
      </div>

      <ToastContainer position="top-center" autoClose={5000} />
    </section>
  );
};

export default Productpage;
